import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n';

const MobileBlocker = () => {
  const navigate = useNavigate();
  const { t, dir } = useLanguage();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4" dir={dir}>
      <div className="max-w-md w-full text-center">
        <div className="bg-zinc-900 rounded-2xl border border-zinc-800 p-8">
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-6 bg-amber-500/20 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          {/* Message */}
          <h2 className="text-2xl font-bold text-white mb-4">
            {t('components.mobileBlocker.title')}
          </h2>
          <p className="text-gray-400 mb-6 leading-relaxed">
            {t('components.mobileBlocker.message')}
          </p>
          <p className="text-gray-500 text-sm mb-8">
            {t('components.mobileBlocker.minimum')}
          </p>

          {/* Back Button */}
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            {t('components.mobileBlocker.backToProjects')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileBlocker;

